import { useEffect, useState } from 'react';
import throttle from 'lodash.throttle';

export default function useElementDimensions(
  elementId: string,
  type: 'client' | 'offset',
) {
  const [elementHeight, setElementHeight] = useState<number | undefined>();
  const [elementWidth, setElementWidth] = useState<number | undefined>();

  useEffect(() => {
    const handleResize = () => {
      const element: HTMLElement | null = document.querySelector(
        `#${elementId}`,
      );
      setElementHeight(
        type === 'client' ? element?.clientHeight : element?.offsetHeight,
      );
      setElementWidth(
        type === 'client' ? element?.clientWidth : element?.offsetWidth,
      );
    };

    const handleResizeThrottled = throttle(handleResize, 50);
    window.addEventListener('resize', handleResizeThrottled);
    handleResize();

    return () => window.removeEventListener('resize', handleResizeThrottled);
  }, [elementId, type]);

  return {
    height: elementHeight,
    width: elementWidth,
  };
}
